import { render, staticRenderFns } from "./DownloadReferencesController.vue?vue&type=template&id=1b1c7982&"
import script from "./DownloadReferencesController.vue?vue&type=script&lang=js&"
export * from "./DownloadReferencesController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports